
import { Routes } from '@angular/router';
import { AppComponent } from './app.component';

import { AppWrapperComponent } from './app-wrapper/app-wrapper.component';
import { SessionExpiredComponent } from './app-wrapper/components/session-expired/session-expired.component';
import { AuthGuard } from './core/auth/auth.guard';
import { ForgotPasswordComponent } from './core/auth/components/forgot-password/forgot-password.component';
import { LoginCredentialsComponent } from './core/auth/components/login-credentials/login-credentials.component';
import { PrivacyPolicyComponent } from './core/auth/components/privacy-policy/privacy-policy.component';
import { RegisterComponent } from './core/auth/components/register/register.component';
import { TermsOfConditionComponent } from './core/auth/components/terms-of-condition/terms-of-condition.component';
import { ForgotPassworContainerComponent } from './core/auth/containers/forgot-password-container/forgot-password.container.component';
import { LoginContainerComponent } from './core/auth/containers/login-container/login.container.component';
import { ResetPasswordContainerComponent } from './core/auth/containers/reset-password/reset-password-container.component';
import { VerifyUserContainerComponent } from './core/auth/containers/verify-user-container/verify-user.container.component';
import { PrintSetlistContainerComponent } from './core/band/containers/print-setlist-container/print-setlist-container.component';

export const routes: Routes = [

    {
        path: '',
        redirectTo: 'app',
        pathMatch: 'full',
    }, {
        path: 'app',
        component: AppComponent,
        children: [
            {
                path: '',
                redirectTo: 'wrapper',
                pathMatch: 'full'
            },
            {
                path: 'wrapper',
                component: AppWrapperComponent,
                canActivate: [AuthGuard],
                children: [
                    {
                        path: '',
                        redirectTo: 'desk',
                        pathMatch: 'full'
                    },
                    {
                        path: 'desk',
                        loadChildren: () => import('./core/desk/desk-routes').then(m => m.DeskRoutes)
                        // loadChildren: () => import('./core/desk/desk.module').then(m => m.DeskModule),
                    }, {
                        path: 'band',
                        // loadChildren: () => import('./core/band/band.module').then(m => m.BandModule),
                        loadChildren: () => import('./core/band/band-routes').then(m => m.bandRoutes),

                    }, {
                        path: 'tools',
                        loadChildren: () => import('./core/tools/tools-routes').then(m => m.toolRoutes),

                    }, {
                        path: 'settings',
                        loadChildren: () => import('./core/settings/settings-routes').then(m => m.settingsRoutes),
                    }
                ]
            },
            {
                path: 'print-setlist/:bandId/:setlistId/:appointmentId',
                component: PrintSetlistContainerComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'login',
                component: LoginContainerComponent,
                children: [
                    { path: '', redirectTo: 'credentials', pathMatch: 'full' },
                    { path: 'register', component: RegisterComponent },
                    { path: 'terms', component: TermsOfConditionComponent },
                    { path: 'privacy', component: PrivacyPolicyComponent },
                    { path: 'forgot-password', component: ForgotPasswordComponent },
                    { path: 'credentials', component: LoginCredentialsComponent }
                ]
            },
            {
                path: 'forgot-password',
                component: ForgotPassworContainerComponent
            },
            {
                path: 'verify-user/:token',
                component: VerifyUserContainerComponent
            },
            {
                path: 'reset-password/:token',
                component: ResetPasswordContainerComponent
            },
            {
                path: 'session-expired',
                component: SessionExpiredComponent
            }, {
                path: '**',
                redirectTo: 'app',
                pathMatch: 'full'
            },
        ]
    }
];
